import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "container", "removeField"]

  showPreview(event) {
    const file = event.target.files[0]

    // If user selects a new file, ensure we do NOT remove existing image on submit
    this.#setRemoveFlag(false)

    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()

      reader.onload = (e) => {
        this.previewTarget.src = e.target.result
        this.previewTarget.classList.remove('hidden')
        this.containerTarget.classList.remove('hidden')
      }

      reader.readAsDataURL(file)
    } else {
      this.removeImage()
    }
  }

  removeImage() {
    this.previewTarget.src = ""
    this.previewTarget.classList.add('hidden')
    this.containerTarget.classList.add('hidden')

    // Set the remove flag so backend purges the attachment
    this.#setRemoveFlag(true)

    // Clear the file input
    const fileInput = this.element.querySelector('input[type="file"]')
    if (fileInput) {
      fileInput.value = ""
    }
  }

  #setRemoveFlag(shouldRemove) {
    if (this.hasRemoveFieldTarget) {
      this.removeFieldTarget.value = shouldRemove ? "1" : "0"
    }
  }
}